import cardImg from "../../../Assets/Images/overallrating/card-img.png";
import "./style.css";
import Carousel from "../../../Components/Carousel";
import { SwiperSlide } from 'swiper/react';

const OverallRatings = () => {
  const options = {
    slidesPerView: 3,
    spaceBetween: 20,
    scrollbar:"",
    className: "mySwiper",
    loop: true,
};
  const myBreakpoints = {
  640: {
    slidesPerView: 1,
    spaceBetween: 20,
  },
  768: {
    slidesPerView: 2,
    spaceBetween: 20,
  },
  1024: {
    slidesPerView: 3,
    spaceBetween: 20,
  },
};
  return (
    <div className="row px-4 my-5">
      <Carousel id="competetions" newOptions={ options} breakpoints={myBreakpoints}>
        <SwiperSlide >
          <div className="col-lg-12 p-0">
            <div className="card-sec p-0">
              <iframe
                width="100%"
                height="100%"
                src="https://www.youtube.com/embed/OEtid9dU070"
              ></iframe>
            </div>
          </div>
        </SwiperSlide>
        <SwiperSlide >
          <div className="col-lg-12 p-0">
        <div className="card-sec row">
          <div className="card-image col-4 col-md-4 d-block p-0">
            <img
              src={cardImg}
              alt="cardImg"
              style={{ width: "80px", height: "120px" }}
            />
            <span>Kanha & Kavita</span>
          </div>
          <div className="card-desc col-7 col-md-8 d-flex align-items-center">
            <p>The organizing team was very supportive throughout.</p>
          </div>
        </div>
      </div>
        </SwiperSlide>
        <SwiperSlide >
          <div className="col-lg-12 p-0">
            <div className="card-sec p-0">
              <iframe
                width="100%"
                height="100%"
                src="https://www.youtube.com/embed/ec7VUTt35bI"
              ></iframe>
            </div>
          </div>
        </SwiperSlide>
        <SwiperSlide >
          <div className="col-lg-12 p-0">
        <div className="card-sec row">
          <div className="card-image col-4 col-md-4 d-block p-0">
            <img
              src={cardImg}
              alt="cardImg"
              style={{ width: "80px", height: "120px" }}
            />
            <span>Kanha & Kavita</span>
          </div>
          <div className="card-desc col-7 col-md-8 d-flex align-items-center">
            <p>The organizing team was very supportive throughout.</p>
          </div>
        </div>
      </div>
        </SwiperSlide>
            </Carousel>
    </div>
  );
};

export default OverallRatings;
